import { Component, OnInit } from '@angular/core';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';

@Component({
  selector: 'app-reffer-and-earn',
  templateUrl: './reffer-and-earn.component.html',
  styleUrls: ['./reffer-and-earn.component.css']
})
export class RefferAndEarnComponent extends BaseClass<any> implements OnInit {
  public data: any = {
    referral_code: '',
    bonus_percentage: 20
  }

  constructor(public service: WebserviceService,
    private _message: MessageService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.getData();
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  getData() {
    this.isLoad = true;
    this.getServices().Get(`${this.env.baseUrl + this.api.refferAndEarn}`).subscribe(
      (res) => {
        if (res.status == true) {
          this.data = res.data;
        } else if (res.status == false) {
          this._message.errmessage(res.error.message);
        }
        this.isLoad = false;
      },
      (err) => {
        this.isLoad = false;
        console.log(err);
      });
  }

  doCopy(acNo: any) {
    navigator.clipboard.writeText(acNo);
    if (acNo != '') {
      this._message.succmessage(`Copied.!! ${acNo}`)
    }
  }


}
